import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { TransferCardAddress } from './transfer-card-address'
import { TransferCardTop } from './transfer-card-top'

import type { TransferFlowReatom } from '../../../atoms/transfer-flow'
import type { WalletModel } from '@root/entities/wallet/atoms'

type TransferCardProps = {
  wallet: WalletModel
  model: TransferFlowReatom
}

export const TransferCard: React.FC<TransferCardProps> = ({
  wallet,
  model,
}) => {
  const { t } = useTranslation()

  return (
    <Root>
      <Item>
        <TransferCardTop wallet={wallet} model={model} />
      </Item>

      <Separator>
        <SendTo>{t('transfer.send-to')}</SendTo>
      </Separator>

      <Item>
        <TransferCardAddress model={model} selectedWallet={wallet} />
      </Item>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
`

const SendTo = styled.div`
  border-radius: 64px;
  background: var(--background-5);

  color: var(--text-12);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  padding-inline: 6.5px;
`

const Separator = styled.div`
  position: relative;
  height: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Item = styled.div`
  border-radius: 16px;
  border: 1px solid var(--backgroundA-1);
  background: var(--backgroundA-2);
  padding: 12px;
`
